/* Baddies – univers Femme / Homme (chargé en defer) */
(function () {
  function isHomme() {
    return document.documentElement.getAttribute('data-side') === 'homme';
  }

  function hommeUrl() {
    var link = document.querySelector('.bd-side-switch--to-homme');
    return link ? link.getAttribute('href') : '/collections/homme';
  }

  // Côté homme, le logo ramène à l'accueil homme
  function fixLogoLinks() {
    if (!isHomme()) return;
    var url = hommeUrl();
    document.querySelectorAll('a.header-logo, a.bd-drawer-logo').forEach(function (a) {
      if (a.getAttribute('href') !== url) a.setAttribute('href', url);
    });
  }

  // Filet de sécurité : si le menu de l'en-tête ne s'est pas replié, on le recalcule
  function reflowHeaderMenu() {
    document.querySelectorAll('#header-component overflow-list').forEach(function (list) {
      if (!list.style.getPropertyValue('--overflow-count')) {
        list.dispatchEvent(new CustomEvent('reflow', { detail: { lastVisibleElement: null } }));
      }
    });
  }

  // Liens « catalogue » : chaque univers pointe vers sa propre collection
  function fixLink(a) {
    if (a.hasAttribute('data-bd-side-target')) return;
    var side = isHomme() ? 'homme' : 'femme';
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (/^\/collections\/all\/?$/.test(url.pathname)) {
      a.setAttribute('href', '/collections/' + side + url.search + url.hash);
    } else if (side === 'homme' && url.pathname === '/' && !url.hash) {
      // côté homme, « Accueil » ramène à l'accueil homme
      a.setAttribute('href', hommeUrl());
    }
  }

  function fixCatalogLinks() {
    document.querySelectorAll('a[href]').forEach(fixLink);
  }

  // Recherche : le compteur n'affiche que les produits de l'univers en cours
  function fixSearchCount() {
    var main = document.querySelector('#MainContent[data-template^="search"]');
    if (!main) return;
    var n = 0;
    main.querySelectorAll('[data-bd-univers]').forEach(function (c) {
      if (c.offsetWidth || c.offsetHeight || c.getClientRects().length) n++;
    });
    main.querySelectorAll('.products-count-wrapper span').forEach(function (s) {
      var txt = n + (n > 1 ? ' articles' : ' article');
      if (s.textContent.trim() !== txt) s.textContent = txt;
    });
    var t = document.title.replace(/\d+\s+résultats?/, n + (n > 1 ? ' résultats' : ' résultat'));
    if (t !== document.title) document.title = t;
  }

  function watchSearch() {
    var main = document.querySelector('#MainContent[data-template^="search"]');
    if (!main || !window.MutationObserver) return;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(fixSearchCount, 80);
    }).observe(main, { childList: true, subtree: true });
  }

  // les menus injectés après coup sont corrigés au moment du clic
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a) fixLink(a);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var target = e.target.closest('[data-bd-side-target]');
    if (target) {
      try { localStorage.setItem('bd-side', target.getAttribute('data-bd-side-target')); } catch (err) {}
    }
    if (e.target.closest('.header__icon--menu')) {
      setTimeout(fixLogoLinks, 20);
    }
  });

  fixLogoLinks();
  fixCatalogLinks();
  fixSearchCount();
  watchSearch();
  window.addEventListener('load', function () {
    fixLogoLinks();
    fixCatalogLinks();
    fixSearchCount();
    setTimeout(reflowHeaderMenu, 300);
    setTimeout(reflowHeaderMenu, 1500);
  });
})();
